import { render, staticRenderFns } from "./activityCommentEditor.vue?vue&type=template&id=65edfe07&scoped=true&"
import script from "./activityCommentEditor.vue?vue&type=script&lang=js&"
export * from "./activityCommentEditor.vue?vue&type=script&lang=js&"
import style0 from "./activityCommentEditor.vue?vue&type=style&index=0&id=65edfe07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65edfe07",
  null
  
)

export default component.exports